import { render, staticRenderFns } from "./favorites-status-profile.vue?vue&type=template&id=635f7391&"
import script from "./favorites-status-profile.vue?vue&type=script&lang=js&"
export * from "./favorites-status-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports